import React from "react";
import { Minus, Plus } from "lucide-react";
import { Button } from "@ndd/ui";

// A labelled value with a minus and a plus: the Availability panel's Starts,
// Ends and lunch break rows (NO-878). The value sits in an <output> between
// two 36px utility buttons; a button that cannot move is disabled.

export interface StepperProps {
  name: string;
  value: string;
  lessLabel: string;
  moreLabel: string;
  noLess: boolean;
  noMore: boolean;
  onLess: () => void;
  onMore: () => void;
}

export function Stepper({
  name,
  value,
  lessLabel,
  moreLabel,
  noLess,
  noMore,
  onLess,
  onMore,
}: StepperProps) {
  return (
    <div className="flex items-center gap-2">
      <span className="w-[52px] text-body-lg font-semibold">{name}</span>
      <Button
        type="button"
        variant="utility"
        className="size-9 flex-none rounded-md p-0"
        aria-label={lessLabel}
        disabled={noLess}
        onClick={onLess}
      >
        <Minus aria-hidden="true" />
      </Button>
      <output className="grid h-9 flex-1 place-items-center rounded-md border border-border-strong font-mono text-reading">
        {value}
      </output>
      <Button
        type="button"
        variant="utility"
        className="size-9 flex-none rounded-md p-0"
        aria-label={moreLabel}
        disabled={noMore}
        onClick={onMore}
      >
        <Plus aria-hidden="true" />
      </Button>
    </div>
  );
}
